import { Box, Button, Divider, Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../common/Breadcrumbs';
import LockedActionButton from '../../common/LockedActionButton';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';

const breadcrumbLinks = [
  { linkName: 'Home', linkUrl: '/' },
  { linkName: 'messaging', linkUrl: '/messaging' },
];

const MessagingPageHeader = () => {
  const isReadOnly = useIsReadOnly();

  return (
    <Box mb="45px">
      <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
      <Text as="h1" color="primaryDark" mt={4} textStyle="heading2">
        Messaging
      </Text>
      <Flex
        align={{ base: 'flex-start', md: 'flex-end' }}
        direction={{ base: 'column', md: 'row' }}
        gap={4}
        justify="space-between"
      >
        <Text color="primaryDark" fontSize="18px" lineHeight="1.3">
          A record of all wallet notifications sent to your pass holders.
        </Text>
        {isReadOnly ? (
          <LockedActionButton
            flexShrink={0}
            fontSize="14px"
            h="43px"
            reason="send-messages"
            px="10px"
            variant="gradient"
            w="150px"
          >
            New notification
          </LockedActionButton>
        ) : (
          <Button
            as={Link}
            flexShrink={0}
            fontSize="14px"
            h="43px"
            to="/messaging/create"
            px="10px"
            variant="gradient"
            w="150px"
          >
            New notification
          </Button>
        )}
      </Flex>
      <Divider
        borderBottomWidth="0.75px"
        borderColor="subheadingGrey"
        mt="26px"
        opacity={1}
      />
    </Box>
  );
};

export default MessagingPageHeader;
